import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { loadNotes } from 'actions';
import { getLoaders, getNotesQuestionnaireId } from 'selectors';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import SurveyNotesContainer from './SurveyNotesContainer';

class SurveyNotesModal extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    loadNotes: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isInitialized: false };
  }

  componentDidMount() {
    const { params } = this.props;
    this.props.loadNotes(params, { source: 'init' });
    this.setState({ isInitialized: true });
  }

  render() {
    const { isLoading, params } = this.props;
    if (!this.state.isInitialized || isLoading) {
      return (
        <div className='column u-margin-top--base u-margin-bottom--base'>
          <LoadingSpinner />
        </div>
      );
    }
    return <SurveyNotesContainer params={params} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: getLoaders(state, ['WEBNOTES']),
    params: {
      playerId: get(state.player, 'player.id', 0),
      playerQuestionnaireId: getNotesQuestionnaireId(state),
    },
  }
}

export default connect(mapStateToProps, { loadNotes })(SurveyNotesModal);
